import React from 'react';
import { Content, Row, Col, Title, Text, Button } from 'components';
import { Input, Spin, Image, Select } from 'antd';
import { SideMenu } from 'routes/main.routes/Mypage/components';
import { csMenu } from '../csMenu';
import plus_w from 'assets/plus_w.svg';

// 문의 유형
const INQUIRY_SUB_TYPE = {
  DELIVERY: '배송',
  BULK: '대량문의',
  ORDER: '주문/결제',
  JM_PAY: 'JM페이',
  USER: '회원정보',
  SERVICE: '서비스',
  ETC: '기타',
};

const HelpInquireFormPresenter = (props) => {
  /* ===== Props ===== */
  const {
    inputValue,
    files,
    isLoading,
    onChange,
    onFileList,
    maxFileCount,
    maxFileSize,
    onSubmit,
    navigate,
    screenSize,
  } = props;

  /* ===== State ===== */
  const fileInputRef = React.useRef(null);

  /* ===== Variables ===== */
  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 24,
      borderBottom: '2px solid var(--black-color)',
    },

    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
    },
    button: {
      padding: '10px 29px',
      borderRadius: '2px',
      backgroundColor: 'transparent',
      border: '1px solid var(--dark-gray-color)',
      color: 'var(--black-color)',
    },
    activeButton: {
      padding: '18px 29px',
      borderRadius: '2px',
    },
    required: {
      color: 'var(--danger-color)',
      padding: '0px 4px',
      lineHeight: 0,
    },
  };

  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px' : '80px 0'}
        >
          <Row gutter={25}>
            <Col x={0} md={2}></Col>
            <Col x={0} md={4}>
              <SideMenu menu={csMenu} title="고객센터" />
            </Col>
            <Col x={24} md={16}>
              <Content
                maxWidth={'100%'}
                padding={screenSize >= 768 ? '0 0 0 95px' : '0'}
              >
                <div
                  style={{
                    ...styles.titleLayout,
                    marginBottom: 32,
                  }}
                >
                  <Title style={{ ...styles.title }}>1:1 문의</Title>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 12,
                    }}
                  >
                    <Text>문의유형</Text>
                    <span style={{ ...styles.required }}>*</span>
                  </div>
                  <Select
                    placeholder="문의 유형을 선택하세요.(필수)"
                    style={{
                      width: '100%',
                      height: 48,
                      marginBottom: 16,
                    }}
                    options={Object.entries(INQUIRY_SUB_TYPE).map(
                      ([key, value]) => ({
                        label: value,
                        value: key,
                      }),
                    )}
                    value={inputValue.type ? inputValue.type : null}
                    onChange={(e) => onChange('type', e)}
                  />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 12,
                    }}
                  >
                    <Text>문의내용</Text>
                    <span style={{ ...styles.required }}>*</span>
                  </div>
                  <Input
                    value={inputValue.name}
                    placeholder="제목을 입력해주세요."
                    style={{
                      border: '1px solid #DDDDDD',
                      height: 48,
                      marginBottom: 32,
                    }}
                    onChange={(e) => onChange('name', e.target.value)}
                  />
                  <Input.TextArea
                    rows={4}
                    placeholder="문의 내용을 입력해주세요."
                    style={{
                      border: '1px solid #DDDDDD',
                      height: 300,
                      marginBottom: 32,
                    }}
                    value={inputValue.content}
                    onChange={(e) => onChange('content', e.target.value)}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: 12,
                    alignItems: 'center',
                    marginBottom: 32,
                  }}
                  onClick={() => fileInputRef.current.click()}
                >
                  <Button
                    style={{
                      padding: '2px 8px',
                      borderRadius: 0,
                      fontSize: 14,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    사진첨부
                  </Button>
                  <input
                    ref={fileInputRef}
                    id="upload"
                    type="file"
                    multiple={true}
                    accept={'image/*'}
                    onChange={(e) => onFileList('add', e.target.files)}
                  />
                  <Text
                    style={{
                      fontSize: 14,
                      webkitLineClamp: 'none',
                      wordBreak: 'keep-all',
                    }}
                  >
                    최대 {maxFileCount}개 / 개당 {maxFileSize / 1024 / 1024}
                    MB까지 첨부 가능합니다. (JPG, JPEG, PNG, GIF만 첨부 가능)
                  </Text>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  {files.map((file, index) => {
                    const link = URL.createObjectURL(file);

                    return (
                      <div
                        key={`image-${index}`}
                        style={{ position: 'relative', top: 0, left: 0 }}
                      >
                        <Image src={link} width={100} height={100} />

                        <button
                          style={{
                            position: 'absolute',
                            top: -10,
                            right: -10,
                            width: 20,
                            height: 20,
                            zIndex: 1,
                            cursor: 'pointer',
                            background: '#111111',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                          onClick={() => onFileList('remove', index)}
                        >
                          <img
                            src={plus_w}
                            alt="plus icon"
                            style={{ transform: 'rotate(45deg)' }}
                          />
                        </button>
                      </div>
                    );
                  })}
                </div>
                {/* <Text style={{ marginBottom: 12 }}>이메일 알림받기</Text>
            <Input
              placeholder="예: jmcoffee@jm.co.kr"
              style={{
                border: '1px solid #DDDDDD',
                height: 48,
                marginBottom: 32,
              }}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
              <Checkbox />
              <Text>답변 알림 받기</Text>
            </div> */}

                <Text
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 32,
                    padding: '32px 0',
                    fontSize: 14,
                    lineHeight: 1.75,
                    borderTop: '1px solid #ddd',
                  }}
                >
                  <span>∙ 접수된 문의는 수정이 불가능합니다.</span>
                  <span>∙ 답변이 완료되면 삭제는 불가능합니다.</span>
                </Text>
                <div
                  maxWidth={'100%'}
                  padding={0}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: screenSize >= 768 ? 24 : 12,
                    marginTop: screenSize >= 768 ? 100 : 60,
                  }}
                >
                  <Button
                    style={{
                      width: '22%',
                      minWidth: 130,
                      padding: screenSize >= 768 ? '18px 52px' : '12px 35px',
                      fontWeight: 700,
                      borderRadius: '2px',
                      backgroundColor: 'var(--white-color)',
                      color: 'var(--black-color)',
                      border: '1px solid var(--black-color)',
                      fontSize: screenSize >= 768 ? 16 : 14,
                    }}
                    onClick={() => navigate(-1)}
                  >
                    취소
                  </Button>
                  <Button
                    style={{
                      width: '22%',
                      minWidth: 130,
                      padding: screenSize >= 768 ? '18px 52px' : '12px 35px',
                      fontWeight: 700,
                      borderRadius: '2px',
                      fontSize: screenSize >= 768 ? 16 : 14,
                    }}
                    onClick={() => onSubmit()}
                  >
                    문의하기
                  </Button>
                </div>
              </Content>
            </Col>
            <Col x={0} md={2}></Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default HelpInquireFormPresenter;
